export const scrollToTarget = (target: string) => {
  if (document !== null) {
    document?.querySelector(`[data-hook="${target}"]`)?.scrollIntoView();
  }
};
